import { createAction } from 'redux-actions';

import {
	GET_OVERTIME_RULE_SETTING_CALL,
	GET_OVERTIME_RULE_SETTING_DONE,
	GET_OVERTIME_RULE_SETTING_FAIL,
} from '@src/store/types';

export const getOvertimeRuleSettingCall = createAction(GET_OVERTIME_RULE_SETTING_CALL);
export const getOvertimeRuleSettingDone = createAction(GET_OVERTIME_RULE_SETTING_DONE);
export const getOvertimeRuleSettingFail = createAction(GET_OVERTIME_RULE_SETTING_FAIL);
